import moment from "moment";
export const orderStatus = Object.freeze({
  UNPAID: "UNPAID",
  PACKING: "PACKING",
  SHIPPING: "SHIPPING",
  ARRIVED: "ARRIVED",
  CANCEL: "CANCEL",
  ERROR: "ERROR"
});

export const actionStatus = {
  none: { label: "無", type: null },
  redirect: { label: "連結", type: "link" },
  popup: { label: "播放影片", type: "link" }
};

export const nationCategories = [
  { key: "negotiation", value: "國際公約與氣候合作", color: "#54BAFF" },
  { key: "greenhouse", value: "溫室氣體減緩政策", color: "#FF6F92" },
  { key: "demand", value: "能源需求面減量措施", color: "#24A9B0" },
  { key: "supply", value: "能源供給面減量措施", color: "#0E9F68" },
  { key: "market", value: "碳管制工具", color: "#EAA82D" },
  // { key: 'adaptation', value: '調適議題', color: '#EA712D' },
  { key: "gender", value: "其他議題", color: "#8889EC" }
  // { key: 'impact', value: '衝擊評估', color: '#67D268' },
  // { key: 'climate', value: '公約外國際氣候會議與合作', color: '#E5505B' },
  // { key: 'strategy', value: '策略措施', color: '#1772DC' }
];

export const activityCategories = [
  { key: "greenTrade", value: "綠色貿易資訊網", color: "#54BAFF" },
  { key: "reduceCarbon", value: "產業節能減碳資訊網", color: "#FF6F92" },
  { key: "pidc5", value: "中小企業綠色環保資訊網-活動資訊", color: "#24A9B0" },
  {
    key: "pidc6",
    value: "中小企業綠色環保資訊網-淨零碳排課程",
    color: "#0E9F68"
  }
];

export const activityTypes = [
  { key: "train", value: "訓練課程" },
  { key: "lecture", value: "講座研討" },
  { key: "exhibition", value: "成果展覽" },
  { key: "visit", value: "參訪觀摩" },
  { key: "communicate", value: "社會溝通" }
];

export const activityTypeKeys = {
  LECTURE: "lecture",
  EXHIBITION: "exhibition",
  COMMUNICATE: "communicate"
};

export const numberSetting = {
  until2050: "2050國家數",
  until2060: "2060國家數",
  until2070: "2070國家數",
  until2080: "2080國家數",
  until2090: "2090國家數",
  until2100: "2100國家數",
  percent: "排放佔比"
};

export const settingPath = {
  home: "首頁"
};

export const NATION_TYPE = {
  PENDING: "PENDING",
  RELEASE: "RELEASE"
};

export const FRONT_END_LINK = [
  { key: "HOME", label: "首頁", path: "/" },
  { key: "REPORT", label: "國內外資訊/動態報導", path: "/report" },
  {
    key: "CARBON_MANAGEMENT",
    label: "盤查登錄",
    path: "/carbonManagement?category=signin"
  },
  { key: "CBAM", label: "國內外碳排管制", path: "/countries/european" },
  { key: "WORLD_DECLARE", label: "格拉斯哥氣候協議", path: "/worldDeclare" },
  { key: "GOV_DECLARE", label: "政府網站資料開放宣告", path: "/govDeclare" },
  { key: "PRIVACY", label: "隱私權政策", path: "/privacy" }
];

export const DATE_PICKER_RANGE = {
  今天: [moment().startOf("day"), moment()],
  前7天: [moment().startOf("day").subtract(7, "days"), moment()],
  本月: [moment().startOf("month"), moment()],
  前一個月: [moment().startOf("month").subtract(1, "months"), moment()],
  前三個月: [moment().startOf("month").subtract(3, "months"), moment()],
  前半年: [moment().startOf("month").subtract(6, "months"), moment()],
  前一年: [moment().startOf("month").subtract(12, "months"), moment()]
};

export const FILE_MAX_SIZE = {
  IMAGE: 2, // MB
  FILE: 10 //MB
};

export const DEFAULT_SMS_VERIFY_CODE = {
  length: 4,
  hasCharacter: false,
  verifyCodeMessage: "【淨零後台服務登入】您的驗證碼為{{code}}，請於15分鐘內驗證。"
};

export const STORAGE_KEYS = {
  FORGET_COUNT: "forget",
  SEND_SMS: "sendSms",
  TOKEN: "JwtToken",
  OPEN_MODAL: "openModal"
};

export const TAG_CATEGORY_TYPES = {
  MAGAZINE: "EBOOK",
  FAQ_CATEGORY: "FAQ_CATEGORY",
  FAQ_SUBCATEGORY: "FAQ_SUBCATEGORY",
};

export const UPDATE_PASSWORD_LIMIT_DAYS = 90;

// Region 類型（歐盟/英國CBAM檔案用）
export const REGION_TYPES = {
  EUROPEAN: "european",
  UK: "uk"
};

// Region 標籤映射
export const REGION_TYPE_LABEL = {
  european: "歐盟",
  uk: "英國"
};
